<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        icon="dashboard"
    ></vuse-section-definition>
    <v-container fluid class="content-setting rounded-lg">
      <v-row justify="center" align="center">
        <v-col>
          <v-btn
          color="primary"
          @click="clearCache"
          >
            clear cache
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {CLEAR_CACHE} from '@/store/modules/setting'
export default {
  data() {
    return {
      page: "Setting",
      breadcrumbs: [
        {
          text: "Setting",
          disabled: true,
        },
      ],
    };
  },
  methods:{
    clearCache(){
      this.$store.dispatch(`${CLEAR_CACHE}`, {})
    }
  }
};
</script>
<style lang="scss">
.content-setting{
  background-color: #ffffff !important;
}
</style>
